export default "__VITE_ASSET__3aa68632__"